import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Icon, IconButton } from '@mui/material';

import { userManagementService } from '../../services/user-management.service';


const PageNotAuthorized: React.FC = () => {
  const navigate = useNavigate();
  const mijnOrganisatie = userManagementService.getStoredOrganisatie();
  const onClickNavigate = (path: string) => {
    if (path.startsWith('http')) {
      window.open(path, '_blank', 'noopener,noreferrer');
    }
    else {
      navigate(path);
    }
  };

  return (
    <>
      <header className="page-header container">
        <h1>Geen toegang</h1>
        <p className="header-sub-title">
          U heeft geen toegang tot dit onderdeel van infraplannen.
        </p>
        
      </header>

      <div className="container content">
        { !mijnOrganisatie && (
          <p>
            Er is nog geen actieve organisatie gekozen. Gebruik menuitem <IconButton size="large"><Icon>domain</Icon></IconButton> om een organisatie te kiezen.
          </p>
        )}

        <div className="btn-group">
          <Button variant="contained" color="secondary" onClick={() => onClickNavigate('/')}>
            Naar startpagina
            <Icon>chevron_right</Icon>
          </Button>

          <Button variant="text" color="secondary" onClick={ () => onClickNavigate('https://mijnaansluiting.atlassian.net/wiki/spaces/Wiki/pages/628588545/Gebruikershandleiding+infraplannen.nl') }>
            Lees de handleiding
            <Icon>chevron_right</Icon>
          </Button>
          <Button variant="text" color="secondary" onClick={ () => onClickNavigate('/contact') }>
            Contact opnemen
            <Icon>chevron_right</Icon>
          </Button>
        </div>
      </div>
    </>
  );
};

export default PageNotAuthorized;